// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLabelValue } from '@tcp/core/src/utils';
import AccountLabels from '@tcp/core/src/components/features/account/Account/views/Account.labels.js';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor/views';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../../utils/labels/labelUtilty';

const mapStateToProps = () => ({});
const ContentLink = ({ urlKey, ...otherProps }) => {
  const dynamicLabels = getDynamicLabelValues('dynamic.account_d');
  const commonLabels = getLabelFromCopyOrFromTranslation('account.common', AccountLabels) || {};
  const updatedLabels = {
    ...{ commonLabels },
    ...(dynamicLabels || {}),
    lbl_privacyPolicy_link: dynamicLabels.lbl_privacyPolicy_link,
    lbl_faq_link: dynamicLabels.lbl_faq_link,
    lbl_policies_link: dynamicLabels.lbl_policies_link,
    lbl_mprTerms_link: dynamicLabels.lbl_mprTerms_link,
  };
  return <Anchor to={getLabelValue(updatedLabels, urlKey)} target="_blank" {...otherProps} />;
};

ContentLink.propTypes = {
  urlKey: PropTypes.string.isRequired,
  commonLabels: PropTypes.shape({}).isRequired,
};

export default connect(mapStateToProps)(ContentLink);
